/**
 * Biểu tượng tròn theo NHÓM tin — nhìn lướt chuông là tách được tin tiền, tin
 * sự cố, tin lịch (CEO chốt 1a, 31/10/2026). Nhóm do máy chủ gửi (`group`);
 * tin không có nhóm dùng chuông xám.
 */

import {
  AlertTriangle,
  Bell,
  CalendarClock,
  Camera,
  Coins,
  Image,
  MessageCircle,
  Printer,
  ShoppingBag,
  Wallet,
  type LucideIcon,
} from "lucide-react";

import type { NotificationGroup } from "./api";

const GROUP_ICON: Record<NotificationGroup, { icon: LucideIcon; tone: string }> = {
  money: { icon: Wallet, tone: "bg-amber-100 text-amber-700" },
  order: { icon: ShoppingBag, tone: "bg-sky-100 text-sky-700" },
  dispatch: { icon: Camera, tone: "bg-violet-100 text-violet-700" },
  shift: { icon: CalendarClock, tone: "bg-teal-100 text-teal-700" },
  photo: { icon: Image, tone: "bg-pink-100 text-pink-700" },
  print: { icon: Printer, tone: "bg-slate-100 text-slate-700" },
  chat: { icon: MessageCircle, tone: "bg-emerald-100 text-emerald-700" },
  incident: { icon: AlertTriangle, tone: "bg-red-100 text-red-700" },
  pay: { icon: Coins, tone: "bg-amber-100 text-amber-700" },
  internal: { icon: Bell, tone: "bg-slate-100 text-slate-600" },
};

export function NotificationGroupIcon({
  group,
  className = "",
}: {
  group?: NotificationGroup | undefined;
  className?: string;
}) {
  const { icon: Icon, tone } = (group && GROUP_ICON[group]) || {
    icon: Bell,
    tone: "bg-slate-100 text-slate-600",
  };
  return (
    <span
      aria-hidden
      className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${tone} ${className}`}
    >
      <Icon className="h-4 w-4" />
    </span>
  );
}
